import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import DashCard from '../components/DashCard'
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import DriveEtaRoundedIcon from '@mui/icons-material/DriveEtaRounded';
import ReceiptLongRoundedIcon from '@mui/icons-material/ReceiptLongRounded';
import PlaylistAddRoundedIcon from '@mui/icons-material/PlaylistAddRounded';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import { getTransactionsFetch, selectFilter } from '../Redux/slices/transactionState'
import TransactionTable from '../components/TransactionTable';
import AddTransactions from '../components/AddTransactions';
import UpdateTransactions from '../components/UpdateTransactions';
import ScrollToTargetAdjusted from '../Utils/ScrollToTargetAdjusted';
import ManageParty from '../components/Party/ManageParty';
import ManageDrivers from '../components/Driver/ManageDrivers';
import { getPartiesFetch } from '../Redux/slices/partyState';
import { getDriversFetch } from '../Redux/slices/driverState';
import { getVehiclesFetch } from '../Redux/slices/vehicleState';
import ManageVehicles from '../components/Vehicle/ManageDrivers';

export default function Landing() {
  const filter =  useSelector(selectFilter)
  const dispatch = useDispatch()
  const [activeTab,setActiveTab] = useState("viewT")
  const [selectedRecord,setSelectedRecord] = useState({docid:null})
  useEffect(()=>{
    dispatch(getPartiesFetch())
    dispatch(getDriversFetch())
    dispatch(getVehiclesFetch())
  },[])
  useEffect(() => {
    console.log("Transaction fetch")
    dispatch(getTransactionsFetch())
    //getTransaction("driver","labour",500,500).then(res=>console.log(res.docs)).catch(e=>console.log(e))
    return () => {

    }
  }, [dispatch,filter])

  const selectRecordHandler= (id)=>{
    setSelectedRecord(id)
    ScrollToTargetAdjusted("updateTransactionForm")
    setActiveTab("viewT")
  }
  const selectToolHandler = (id)=>{
    setActiveTab(id)
    setSelectedRecord({docid:null})
  }


  return (
    <div className='w-full pt-10 lg:px-20 md:px-10'>
      <div className="flex flex-wrap text-center justify-center items-stretch">
        <DashCard title="Add Transactions" desc='Add New Transactions' Icon={<PlaylistAddRoundedIcon sx={{ fontSize: 50 }} color='primary'  />} onClickHandler={()=>selectToolHandler('addT')}  active={activeTab==="addT"}/>
        <DashCard title="View Transactions" desc='View transaction history & filter results' Icon={<ReceiptLongRoundedIcon sx={{ fontSize: 50 }} color='primary'/>} onClickHandler={()=>selectToolHandler('viewT')} active={activeTab==="viewT"} />
        <DashCard title="Manage Party" desc=' Add and manage partys' Icon={<SupervisorAccountIcon sx={{ fontSize: 50 }} color='primary' />} onClickHandler={()=>selectToolHandler('manageP')} active={activeTab==="manageP"} />
        <DashCard title='Manage Drivers' desc='Add and manage drivers' Icon={<DriveEtaRoundedIcon sx={{ fontSize: 50 }} color='primary' />} onClickHandler={()=>selectToolHandler('manageD')} active={activeTab==="manageD"} />
        <DashCard title='Manage Vehicles' desc='Add and manage Vehicles' Icon={<LocalShippingIcon sx={{ fontSize: 50 }} color='primary' />} onClickHandler={()=>selectToolHandler('manageV')} active={activeTab==="manageV"} />
      
      </div>
      {activeTab==="addT"&&!selectedRecord.docid&&<AddTransactions />}
      {(activeTab==="viewT"||activeTab==="addT")&&selectedRecord.docid&&<UpdateTransactions formData={selectedRecord} setFormData={setSelectedRecord} />}
      {(activeTab==="viewT"||activeTab==="addT")&&<TransactionTable selectedRecord={selectedRecord} selectHandler={selectRecordHandler}/>}
      {activeTab==="manageP"&&<ManageParty/>}
      {activeTab==="manageD"&&<ManageDrivers/>}
      {activeTab==="manageV"&&<ManageVehicles/>}


    </div>
  )
}




